// Valid color variants
export type ColorVariant = 'primary' | 'natural' | 'success' | 'secondary' | 'warning' | 'danger';

// Valid shade values
export type ColorShade = 5 | 10 | 20 | 40 | 60 | 80 | 100 | 120 | 140 | 160 | 180;

// Our scss colors i.e. --color-primary-100, --color-danger-5, ...
export type AccredibleColor = `--color-${ColorVariant}-${ColorShade}`;
